<script  lang="ts">
    import { service } from "@frontend/services";
    import { GetCachedToken } from "@frontend/user";
    import { ApiResultOfPublicUserDTO, EditUserDTO, type User } from "@frontend/walletapi";
     import { translate, currentLanguage } from "../Translator";
  
    export let user: User;
    export let dismiss: () => void;
  
    let result: ApiResultOfPublicUserDTO | undefined = undefined;
    let editUser: EditUserDTO = {
      ...user,
      NewPassword: undefined,
      Language: user.Language || undefined
    }
  
    async function EditUser() {
      result = await service.walletapi.editUser({
          Token: GetCachedToken(),
          Data: editUser
      });
    }
  
  </script>
  
  
  <h2 class="ui centered dividing header">{$translate('Edit')} {user.Role} #{editUser.Id}</h2>
  {#if result && result.Success && result.Data}
      <div class="ui positive message">
          <div class="header">
              {user.Role} {$translate('Edited successfully')}
          </div>
      </div>
  
      <div class="ui segment" style="display: flex;">
          <table class="receit-table" style="flex-grow: 1;">
              <tr>
                  <td class="receit-title">{$translate('Id')}</td>
                  <td class="receit-value">#{result.Data.Id}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('First Name')}</td>
                  <td class="receit-value">{result.Data.FirstName}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate ('Last Name')}</td>
                  <td class="receit-value">{result.Data.LastName ?? ""}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('E-mail')}</td>
                  <td class="receit-value">{result.Data.Email ?? ""}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('Phone Number')}</td>
                  <td class="receit-value">{result.Data.PhoneNumber ?? ""}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('Language')}</td>
                  <td class="receit-value">{result.Data.Language?.toUpperCase() ?? "N/A"}</td>
              </tr>
              <tr>
                  <td class="receit-title">{$translate('Password')}</td>
                  <td class="receit-value">********</td>
              </tr>
              <!-- <tr>
                  <td class="receit-title">Balance</td>
                  <td class="receit-value">{formatMoney(result.Data.Balance?.InCents)}</td>
              </tr> -->
          </table>
      </div>
  
      <div style="display: flex; justify-content: center;">
          <button class="ui primary fluid button" on:click={dismiss}>{$translate('Dismiss')}</button>
          <button class="ui fluid button">{$translate('Print')}</button>
      </div>
  {:else}
      {#if result && !result.Success}
          <div class="ui negative message">
              <div class="header">{$translate('Error')}</div>
              <p>{result.ErrorMessage ?? `Unknown error when adding ${user.Role}`}</p>
          </div>
      {/if}
      <form class="ui positive form" on:submit|preventDefault={EditUser}>
          <div class="field">
              <label>{$translate('First Name')}
                  <input type="text" class="ui input" placeholder="First name..." bind:value={editUser.FirstName}  required/>
              </label>
          </div>
          <div class="field">
              <label>{$translate('Last Name')}
                  <input type="text" class="ui input" placeholder="Last name..." bind:value={editUser.LastName}  required/>
              </label>
          </div>
          <div class="field">
              <label>{$translate('E-mail')}
                  <input type="text" class="ui input" placeholder="Email..." bind:value={editUser.Email} />
              </label>
          </div>
          <div class="field">
              <label>{$translate('Phone Number')}
                  <input type="text" class="ui input" placeholder="Phone number..." bind:value={editUser.PhoneNumber} />
              </label>
          </div>
          <div class="field">
              <label>{$translate('Language')}
                  <select class="ui dropdown" bind:value={editUser.Language}>
                      <option value="">{$translate('Select a language')}</option>
                      <option value="en">English (EN)</option>
                      <option value="es">Español (ES)</option>
                  </select>
              </label>
          </div>
          <!-- <div class="field">
              <label for="">New password</label>
              <div style="display: flex; align-items: center; justify-content: center;">
                  {#if editUser.ChangePassword}
                      <button class="ui positive labeled icon fluid button" on:click|preventDefault={() => editUser.ChangePassword = false}>
                          <i class="check icon"></i>
                          Generate new password
                      </button>
                  {:else}
                      <button class="ui labeled icon fluid button" on:click|preventDefault={() => editUser.ChangePassword = true}>
                          <i class="close icon"></i>
                          Keep old password
                      </button>
                  {/if}
              </div>
          </div> -->
          <div class="field">
            <label>{$translate('Password')}
                <input type="password" class="ui input" placeholder="Enter new password..." bind:value={editUser.NewPassword} />
            </label>
        </div>
          <div class="two field" style="display: flex">
              <button class="ui negative fluid button" on:click={dismiss}>{$translate('Cancel')}</button>
              <button class="ui positive fluid button">{$translate('Edit')} {user.Role}</button>
          </div>
      </form>
  {/if}
  
  <style>
      .receit-table
      {
          border-spacing: 0px;
          font-family: 'Courier New', Courier, monospace;
      }
  
      .receit-table td
      {
          padding-top: 5px;
      }
  
      .receit-table td:first-child
      {
          margin-right: 0.2em;
      }
  
      .receit-title
      {
          text-align: left;
          border-bottom: 1px solid black;
          padding-right: 10px;
      }
  
      .receit-value
      {
          text-align: right;
          border-bottom: 1px solid black;
      }
  </style>
  
  